import { useQuery } from '@tanstack/react-query';
import { metricsService } from '../services/metrics.service';

export const usePopularPodcastsByLanguage = (language: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['metrics', 'popular-podcasts', language],
    queryFn: () => metricsService.getPopularPodcastsByLanguage(language),
    enabled: enabled && language.length > 0,
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};

export const useAvailableLanguages = () => {
  return useQuery({
    queryKey: ['metrics', 'available-languages'],
    queryFn: () => metricsService.getAvailableLanguages(),
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
  });
};

export const useLocalPodcastEpisodes = (podcastUuid: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['metrics', 'local-episodes', podcastUuid],
    queryFn: () => metricsService.getLocalPodcastEpisodes(podcastUuid),
    enabled: enabled && podcastUuid.length > 0,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
